/**
 * ErrorInline — uniform inline error w/ retry button.
 *
 * Usage:
 *   <ErrorInline message="Couldn't load tasks" onRetry={refresh} />
 */
import { AlertTriangle, RefreshCw } from "lucide-react";

export default function ErrorInline({ message, onRetry, className = "" }) {
  if (!message) return null;
  return (
    <div
      data-testid="error-inline"
      className={
        "card-soft flex items-center justify-between gap-3 rounded-2xl border border-rose-100 bg-rose-50/50 px-4 py-3 " +
        className
      }
    >
      <div className="flex items-center gap-2.5 text-[12.5px] text-rose-900">
        <AlertTriangle className="h-4 w-4 flex-shrink-0 text-rose-600" strokeWidth={2.4} />
        <span className="font-semibold">{message}</span>
      </div>
      {typeof onRetry === "function" && (
        <button
          type="button"
          data-testid="error-inline-retry"
          onClick={onRetry}
          className="inline-flex items-center gap-1.5 rounded-full border border-rose-200 bg-white px-3 py-1.5 text-[11.5px] font-semibold text-rose-700 transition-colors hover:bg-rose-50"
        >
          <RefreshCw className="h-3 w-3" strokeWidth={2.6} />
          Retry
        </button>
      )}
    </div>
  );
}
